module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/3-181403962caf61f4700534834a46d9fc.png";